import { useState } from "react";
import HexCard from "../../../../../components/HexCard";
import { getLabel } from "../../../../../hooks/use-labels";
import DeliveryTypeModal from "./DeliveryTypeModal";


import { getDeliveryTypeValue } from "./delivery-type-card-utils";
import HexIconContent from "../../../../../components/HexIconContent";

const DeliveryTypesCard = ({ cartId, disabled }) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal((prev) => !prev);
  };

  return (
    <HexCard className={"mb-20 delivery-type-card image-content-card"}>
      {modal &&  (
        <DeliveryTypeModal cartId={cartId} onClose={toggleModal} />
      )}

      <HexIconContent
        className={!disabled && "pointer"}
        onClick={!disabled ? () => toggleModal() : null}
        title={getLabel("deliveryTypeLabel")}
        titleClass={"font-18-regular-500-lh-22"}
        value={getDeliveryTypeValue()}
        valueClass="image-content-description"
        icon={"/assets/icons/shopping-cart/delivery-types.svg"}
      />
    </HexCard>
  );
};

export default DeliveryTypesCard;
